var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBackpack = function SvgBackpack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 11.007h4",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 20v-4.945h8V20M9.08 7.344V5.037a2 2 0 0 1 2-2h1.838a2 2 0 0 1 2 2v2.307",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 16h-2v2h2v-2Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20V9.03a2 2 0 0 1 2-2h11.979a2 2 0 0 1 2 2V21H5",
    stroke: "currentColor",
    strokeWidth: 2
  })));
};

export { SvgBackpack as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xMCAxMS4wMDczSDE0IiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0ic3F1YXJlIi8+CjxwYXRoIGQ9Ik04IDIwLjAwMDFWMTUuMDU0N0gxNlYyMC4wMDAxIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIi8+CjxwYXRoIGQ9Ik05LjA4MDA4IDcuMzQzODdWNS4wMzY2MkM5LjA4MDA4IDMuOTMyMDUgOS45NzU1MiAzLjAzNjYyIDExLjA4MDEgMy4wMzY2MkgxMi45MTc5QzE0LjAyMjUgMy4wMzY2MiAxNC45MTc5IDMuOTMyMDUgMTQuOTE3OSA1LjAzNjYyVjcuMzQzODciIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjIiLz4KPHBhdGggZD0iTTE0IDE2SDEyVjE4SDE0VjE2WiIgZmlsbD0iY3VycmVudENvbG9yIi8+CjxwYXRoIGQ9Ik00IDIwVjkuMDMwNTJDNCA3LjkyNTk1IDQuODk1NDMgNy4wMzA1MiA2IDcuMDMwNTJIMTcuOTc5QzE5LjA4MzYgNy4wMzA1MiAxOS45NzkgNy45MjU5NSAxOS45NzkgOS4wMzA1MlYyMS4wMDA0SDUiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjIiLz4KPC9zdmc+Cg==";